import React, { useState, useEffect } from "react";
import axios from "axios"; 
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link from React Router

const API_URL = process.env.REACT_APP_API_URL_EC2;

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const category = "books"; // Set category dynamically if needed

  const GamingURL = "https://ipfs.io/ipfs/bafkreihtie3yml4vacg65lhe5wwbn4jyfg4egfbklsysns44baw5ebiv3u";


  // Define headers as a constant
  const headers = {
    "x-api-key": "L1Lw1If3Rgac1dLLRnfpQ3AkhfCjKlua5Lp50jsw",
    "Content-Type": "application/json",
  };
   
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${GamingURL}`
      );
  
      console.log("Response:", response.data);
      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error.response?.data || error.message);
    }
  };
  
  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <Container className="py-4">
      <Row>
        {products.map((product) => (
          <Col key={product._id} xs={12} sm={6} md={4} className="mb-4">
            <Card className="shadow-sm text-center h-100">
              <Card.Img
                variant="top"
                src={product.image}
                alt={product.title}
                style={{
                  height: "320px",
                  objectFit: "contain", // Ensure the entire image fits within the container
                  width: "100%",
                }}
              />
              <Card.Body>
                <Card.Title className="text-sm">{product.title}</Card.Title>
                <Card.Text className="text-muted">${product.price}</Card.Text>
                {/* Pass productId and category in the URL */}
                <Link to={`/producta/${category}/${product.price}/${encodeURIComponent(product.title)}/${encodeURIComponent(product.image)}/${encodeURIComponent(product.slink)}`}>
                  <Button variant="primary" size="sm">Explore</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProductGrid;
